import { createContext } from 'react';
import { InitialDataContextValue } from './types';

export const InitialDataContext = createContext<InitialDataContextValue | undefined>(undefined);
